import { YesNoQuestion } from '@/gql/graphql';
import { useMemo } from 'react';
import { PillRow } from './pill-row.question-title';

interface QuestionTitleProps {
  index: number;
  question: YesNoQuestion;
}

export const QuestionTitle = ({ index, question }: QuestionTitleProps) => {
  const questionNumber = useMemo(() => {
    return index + 1 + '.';
  }, [index]);

  return (
    <div
      className="inline-flex gap-x-2 items-center justify-start"
      data-testid={`question-${question.id}-tailored-container`}
    >
      <p data-testid={`question-${question.id}-input-id`} className="typo-primary-500 text-secondary-text">
        {questionNumber}
      </p>
      <PillRow
        questionId={question.id}
        designObligations={question.tailoredDesignObligations}
        buildingBlocks={question.tailoredBuildingBlocks}
      />
    </div>
  );
};
